import { css } from '@emotion/react';
export default {
    labelCount: css `
    padding: 0 6px;
  `,
    icon: css `
    height: 18px;
    width: 18px;
  `,
    listRoot: css `
    transition: transform 0.3s ease, opacity 0.1s ease;
    will-change: transform, opacity;

    li:last-child {
      border-bottom: none;
    }
  `,
    listHidden: css `
    transform: translateY(-20px);
  `,
    listAppear: css `
    transform: translateY(5px);
  `,
};
